import { render, staticRenderFns } from "./PageBuilder.vue?vue&type=template&id=92cc522c&scoped=true&"
import script from "./PageBuilder.ts?vue&type=script&lang=ts&"
export * from "./PageBuilder.ts?vue&type=script&lang=ts&"
import style0 from "./PageBuilder.scss?vue&type=style&index=0&id=92cc522c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92cc522c",
  null
  
)

export default component.exports